module.exports = __webpack_public_path__ + "static/media/add-service-01.930ab6cb.png";